/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-access.reducer';

export const PharmacyAccessDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyAccessEntity = useAppSelector(state => state.pharmacyAccess.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyAccessDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyAccess.detail.title">PharmacyAccess</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyAccess.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyAccessEntity.id}</dd>
          <dt>
            <span id="uhid">
              <Translate contentKey="tinyMedicRestApp.pharmacyAccess.uhid">Uhid</Translate>
            </span>
          </dt>
          <dd>{pharmacyAccessEntity.uhid}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyAccess.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyAccessEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="revoked">
              <Translate contentKey="tinyMedicRestApp.pharmacyAccess.revoked">Revoked</Translate>
            </span>
          </dt>
          <dd>{pharmacyAccessEntity.revoked ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacyAccess.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacyAccessEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyAccess.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyAccessEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyAccess.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pharmacyAccessEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyAccess.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyAccessEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyAccess.comboUser">Combo User</Translate>
          </dt>
          <dd>{pharmacyAccessEntity.comboUser ? pharmacyAccessEntity.comboUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyAccess.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{pharmacyAccessEntity.glucoUser ? pharmacyAccessEntity.glucoUser.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-access" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-access/${pharmacyAccessEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyAccessDetail;
